var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-divider'), _c('div', {
    staticClass: "mx-auto my-4 d-flex",
    staticStyle: {
      "max-width": "360px"
    }
  }, [_c('div', {
    staticClass: "mx-2 my-auto",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require("@/assets/media.png")
    }
  })], 1), _c('div', {
    staticClass: "mx-2 my-auto",
    staticStyle: {
      "width": "75%"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Version')) + " " + _vm._s(_vm.$version))]), _c('p', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('Version Info')))])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }